import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase/config';
import { doc, getDoc } from 'firebase/firestore';

const VerificarCodigo = () => {
  const [codigo, setCodigo] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleVerificar = async (e) => {
    e.preventDefault();
    setError('');

    const email = localStorage.getItem('recoveryEmail');
    if (!email) {
      setError('Correo no encontrado. Intenta nuevamente.');
      return;
    }

    try {
      const docRef = doc(db, 'passwordResets', email);
      const snap = await getDoc(docRef);

      if (!snap.exists()) {
        setError('Código inválido o expirado.');
        return;
      }

      const data = snap.data();

      if (Date.now() > data.expiresAt) {
        setError('El código ha expirado. Solicita uno nuevo.');
        return;
      }

      if (codigo !== data.code) {
        setError('El código ingresado es incorrecto.');
        return;
      }

      navigate('/nueva-contraseña');
    } catch (err) {
      console.error('❌ Error al verificar código:', err);
      setError('Error al verificar el código. Intenta nuevamente.');
    }
  };

  return (
    <div
      className="min-h-screen flex justify-center items-center px-4"
      style={{
        background: "linear-gradient(to bottom right, #EAF6FF, #DCEFFF, #F8FAFC)",
      }}
    >
      <div className="
        w-full max-w-md
        bg-white/60 backdrop-blur-xl
        rounded-3xl
        shadow-[0_18px_50px_-15px_rgba(58,106,255,0.35)]
        ring-1 ring-blue-100
        p-8
      ">
        <h1 className="text-3xl md:text-4xl font-extrabold text-blue-900 text-center mb-6">
          Verificar código
        </h1>

        <form onSubmit={handleVerificar} className="space-y-5">

          <input
            type="text"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            placeholder="Código de verificación"
            className="
              w-full px-4 py-3
              border border-blue-100
              rounded-xl
              bg-white/90
              text-center text-lg tracking-widest
              focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]
            "
            required
          />

          <button
            type="submit"
            className="
              w-full bg-[#3A6AFF] hover:bg-blue-700
              text-white py-3 rounded-xl
              font-semibold transition
            "
          >
            Verificar
          </button>
        </form>

        {error && (
          <p className="text-red-500 text-sm mt-4 text-center">
            {error}
          </p>
        )}

        <p className="text-center text-sm mt-6">
          ¿No recibiste el código?{' '}
          <button
            onClick={() => navigate('/recuperar')}
            className="text-blue-600 hover:underline"
          >
            Reenviar
          </button>
        </p>
      </div>
    </div>
  );
};

export default VerificarCodigo;
